import { z } from 'zod';
export const checkoutTierSchema = z.enum(['STARTUP', 'SCALEUP']);
export const checkoutRequestSchema = z.object({ tier: checkoutTierSchema }).strict();
export const checkoutKeySchema = z.string().uuid().transform(value => value.toLowerCase());
export const checkoutResponseSchema = z.object({ url: z.string().max(2048).url().refine(value => {
  const url = new URL(value); return url.origin === 'https://checkout.stripe.com' && !url.username && !url.password;
}) }).strict();
export type CheckoutTier = z.infer<typeof checkoutTierSchema>;
export const checkoutErrorCodeSchema = z.enum(['BILLING_CHECKOUT_INVALID', 'BILLING_CHECKOUT_CONFLICT',
  'BILLING_CHECKOUT_BUSY', 'BILLING_CHECKOUT_RECONCILIATION_REQUIRED', 'BILLING_CHECKOUT_UNAVAILABLE']);
export type CheckoutErrorCode = z.infer<typeof checkoutErrorCodeSchema>;
